export default __webpack_public_path__ + "assets/svg/circle-logo-green.e4860cba522d150fef241ed507012433.svg";